import React, { Component, createRef } from "react";
import PropTypes from "prop-types";

export default class Pin extends Component {
  constructor(props) {
    super(props);
    this.onScroll = this.onScroll.bind(this);
    this.state = {
      pin: document.body.scrollTop > this.props.y,
    };
    this.contentRef = createRef();
  }

  componentWillMount() {
    window.addEventListener("scroll", this.onScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.onScroll);
  }

  onScroll(e) {
    this.setState({
      pin: document.body.scrollTop > this.props.y,
    });
  }

  render() {
    const { children } = this.props;

    if (this.state.pin) {
      const style = {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
      };

      const spacerStyle = {
        height: this.contentRef?.current.offsetHeight,
      };

      return (
        <div style={spacerStyle}>
          <div style={style} ref={this.contentRef}>
            {children}
          </div>
        </div>
      );
    }

    return <div ref={this.contentRef}>{children}</div>;
  }
}

Pin.propTypes = {
  children: PropTypes.node,
};
